import React from 'react';
import classNames from 'classnames';

import ImageWithFallback from 'components/ImageWithFallback';
import ZpButton from 'components/zpButton';
import { importStatic } from 'utils';

import styles from './ResumeCalloutSectiom.module.css';

const ResumeCalloutSection = () => (
  <div className={classNames(styles['sec-byr-free'], 'text-center pb-0')}>
    <h2 className="brandonH1 text-white mx-auto text-center z-mb-38">
      Build A Free Resume With Zippia In Minutes
    </h2>
    <div className="rb-cta-btn-wrap text-white byr-button">
      <a role="button" href="/resume-builder/">
        <ZpButton theme="super-primary" size="big">
          Build My Resume
        </ZpButton>
      </a>
    </div>
    <div className="row no-gutters mt-5">
      <div className={`col-12 d-flex align-items-end justify-content-center overflow-hidden`}>
        <div className={`${styles['resume-preview-image-container']}`}>
          <div
            className={`${styles['resume-preview-image-side']} ${styles['resume-preview-image']} ${styles['resume-preview-image-side-left']}`}
          >
            <ImageWithFallback
              height={331}
              width={255}
              src={importStatic('/ui-router/images/resume-builder/themes/colored/5.1.webp')}
              fallbackSrc={importStatic('/ui-router/images/resume-builder/themes/colored/5.1.png')}
              alt="resume-sample-1"
            />
          </div>
          <div
            className={`${styles['resume-preview-image-main']} ${styles['resume-preview-image']}`}
          >
            <ImageWithFallback
              height={390}
              width={302}
              src={importStatic('/ui-router/images/resume-builder/themes/colored/3.1.webp')}
              fallbackSrc={importStatic('/ui-router/images/resume-builder/themes/colored/3.1.png')}
              alt="resume-sample-3"
            />
          </div>
          <div
            className={`${styles['resume-preview-image-side']} ${styles['resume-preview-image']} ${styles['resume-preview-image-side-right']}`}
          >
            <ImageWithFallback
              height={331}
              width={255}
              src={importStatic('/ui-router/images/resume-builder/themes/colored/2.1.webp')}
              fallbackSrc={importStatic('/ui-router/images/resume-builder/themes/colored/2.1.png')}
              alt="resume-sample-2"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ResumeCalloutSection;
